
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		id: {
			type: String,
			default: Math.random()
				.toString(36)
				.substring(7),
		},
		label: String,
		type: {
			type: String,
			default: 'text',
		},
		name: String,
		placeholder: String,
		value: String,
		modelValue: String,
		step: {
			type: Number,
			default: 1,
		},
		marginBottom: {
			type: Boolean,
			default: true,
		},
		autocomplete: {
			type: Boolean,
			default: true,
		},
	},

	setup(props, { emit }) {
		const changeInputValue = (event: any) => {
			emit('update:modelValue', event.target.value);
		};

		return {
			changeInputValue,
		};
	},
});
